import React from 'react'
import { Row, Col } from 'react-bootstrap';
import styled from 'styled-components';
import Skill from './Skill';

const SkillsSection = styled.section`
background-color: white;
padding: 20px;
margin: 20px 0px;
box-shadow: 0 0 10px rgb(136 136 136 / 20%);
border-radius: 5px;
h5{
    font-size: 14px;
font-weight: 700;
color: #787575;
}
h6{
    font-size: 15px;
    font-weight: 700;
    margin-bottom: 20px;
}
`;

export default function TeacherSkill() {
    return (
        <SkillsSection >
            <Row>
                <Col lg={6} >
                    <div>
                        <h6>Skill Personal</h6>
                        <Skill />
                        <Skill />
                        <Skill />
                        <Skill />
                    </div>
                </Col>
                <Col lg={6} >
                    <div>
                        <h6>Language Personal</h6>
                        <Skill />
                        <Skill />
                        <Skill />
                        <Skill />
                    </div>
                </Col>
            </Row>
        </SkillsSection>
    )
}
